import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PaymentFormModal from "./components/PaymentFormModal";
import PaymentTipsModal from "./components/PaymentTipsModal";
import { checkoutInvoice } from "../../../../../store/checkoutInvoice";
import { usePaymentFlow } from "../../hooks/usePaymentFlow";
import { useInvoice } from "../../hooks/invoice/useInvoice";
import { useInvoiceActions } from "../../hooks/useInvoiceActions";
import { dispatch } from "../../../../../store/store";
import { useSunbitForm } from "./hooks/useSunbitForm";
import { uiNotification } from "../../../../../services/UINotificationService";

const ViewChargeSunbit = ({ history, isTipsApplying }) => {
  const { showTipsModal } = usePaymentFlow();
  const { invoice, amountToPay } = useInvoice();
  const { chargeSunbit } = useInvoiceActions();

  const goToInvoice = () => {
    if (!invoice?.id || !invoice?.patient?.id) return;
    history.push(`/sales/invoice/${invoice.id}/${invoice.patient.id}/invoices`);
  };

  const handlePayment = ({ email, phoneNumber }) => {
    chargeSunbit
      .initiate({ amount: amountToPay, email, phoneNumber })
      .then((response) => {
        uiNotification.success(response?.data?.message);
        goToInvoice();
      })
      .catch((e) => {
        uiNotification.error(e?.response?.data?.message);
      })
      .finally(() => {
        dispatch(checkoutInvoice.actions.paymentViewClose());
      });
  };

  const form = useSunbitForm({
    showTipsModal,
    onPayment: handlePayment,
  });

  return showTipsModal.value ? (
    <PaymentTipsModal
      isTipsApplying={isTipsApplying}
      showTipsModal={showTipsModal}
      form={form}
      isLoading={chargeSunbit.isLoading}
    />
  ) : (
    <PaymentFormModal
      isTipsApplying={isTipsApplying}
      form={form}
      isLoading={chargeSunbit.isLoading}
    />
  );
};

const mapStateToProps = (state) => ({
  isTipsApplying: checkoutInvoice.selectors.selectIsTipsApplying(state),
});

export default withRouter(connect(mapStateToProps)(ViewChargeSunbit));
